module.exports = __webpack_public_path__ + "static/media/rawpixel-com-2.9f845861.jpg";